import {Vue} from 'vue-property-decorator';
import TruncateFilter from '@/filters/truncate.filter';
import TranslateFilter from '@/filters/translate.filter';
import SliceFilter from '@/filters/slice.filter';
import TimerFilter from '@/filters/timer.filter';

Vue.filter('truncate', TruncateFilter.transform);
Vue.filter('translate', TranslateFilter.transform);
Vue.filter('slice', SliceFilter.transform);
Vue.filter('timer', TimerFilter.transform);
